<template>
    <div>
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="page-breadcrumb border-bottom">
        <div class="row">
          <div class="col-lg-3 col-md-4 col-xs-12 align-self-center title">
            <h5 class="font-medium text-uppercase mb-0">Links Generator</h5>
            <button @click="generate" class="mr-2 btn btn-primary">Generate</button>
          </div>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="page-content container-fluid">
        <!-- ============================================================== -->
        <!-- Start Page Content -->
        <!-- ============================================================== -->
        <section class="generator-container">
          <section>
            <label for="input-links" cols="30">Input <span class="sample">(For E.g: https://ahaslides.com/features/random-team-generator/)</span></label>
            <textarea ref='input-links' id="input-links"></textarea>
          </section>
          <section>
            <section class="output-header">
              <label for="output-links">Output</label>
              <button @click="copy">{{ copyText }}</button>
            </section>
            <textarea ref='output-links' id="output-links"></textarea>
          </section>
        </section>
      </div>
    </div>
  </template>

<script>
import { languageCodes } from '@/constants/languageCode.constant';

export default {
  data() {
    return {
      copyText: 'COPY'
    }
  },
  methods: {
    generate() {
      const inputLinks = this.$refs['input-links'].value;
      const outputLinks = this.$refs['output-links'];
      const links = inputLinks.split('\n').filter(Boolean);

      let generatedLinks = [];
      links.forEach(link => {
        const url = new URL(link);
        languageCodes.forEach(language => {
          let newUrl = `${url.origin}/${language}${url.pathname}${url.search}`;
          generatedLinks.push(newUrl);
        });
      });
      outputLinks.value = generatedLinks.join('\n');
    },
    copy() {
      this.copyText = 'COPIED!';
      setTimeout(() => {
        this.copyText = 'COPY';
      }, 500);

      const outputLinks = this.$refs['output-links'];
      outputLinks.select();
      document.execCommand('copy');
    }
  }
}
</script>


<style lang="scss" scoped>
  .title {
    display: flex;
    gap: 1rem;
    justify-content: flex-start;

    & > * {
      flex: 1;
    }
  }

  .generator-container {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 1fr;

    & > * {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      & > textarea {
        height: 500px;
        resize: none;
      }
    }

    & .output-header {
      display: flex;
      justify-content: space-between;
      align-items: center;  
    }

    & .sample {
      font-size: 0.8rem;
      color: #666;
    }

  }
</style>